
import { computed, defineComponent, PropType } from 'vue';
import useStatus from './useStatus';
import { TRAFFIC_STATE_HINT, trafficOf } from './useTraffic';
import { StatusItem } from '@/types';

export default defineComponent({
  name: 'CardItem',
  props: {
    server: {
      type: Object as PropType<StatusItem>,
      default: () => ({})
    }
  },
  setup(props) {
    const {
      getStatus, getCpuStatus, getRAMStatus, getHDDStatus,
      getProcessBarStatus, tableRowByteConvert
    } = useStatus(props);
    const traffic = computed(() => trafficOf(props.server));
    const trafficHint = computed(() => TRAFFIC_STATE_HINT[traffic.value.state]);
    // 不限额时右上角直接显示用量，有额度时显示百分比
    const trafficValue = computed(() => {
      if (traffic.value.state === 'offline') return '–';
      return traffic.value.limited
        ? `${traffic.value.rawPercent}%`
        : tableRowByteConvert.value(traffic.value.used);
    });
    return {
      getStatus, getCpuStatus, getRAMStatus, getHDDStatus,
      getProcessBarStatus, tableRowByteConvert,
      traffic, trafficHint, trafficValue
    };
  }
});
